export default __webpack_public_path__ + "static/media/main_2.27d4a691.jpeg";